import { useState, useEffect } from "react";
import { apiFetch } from "../services/api";

export function useAuthedApi(url, token, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!url) {
      setData(null);
      setLoading(false);
      return;
    }

    let mounted = true;
    setLoading(true);
    apiFetch(url, {}, token ? { authToken: token } : {})
      .then(async (r) => {
        const body = await r.json().catch(() => null);
        if (!r.ok)
          throw new Error(body?.error || body?.message || "Request failed");
        return body;
      })
      .then((body) => {
        if (!mounted) return;
        setData(body);
        setError(null);
      })
      .catch((e) => {
        if (!mounted) return;
        setError(e);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });

    return () => {
      mounted = false;
    };
  }, [url, token, ...deps]);

  return { data, loading, error };
}
